var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-page"},[_c('img',{attrs:{"src":require("@/assets/image/default/errorText.png")}}),_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])
}]

export { render, staticRenderFns }